import React, { useState } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Paper,
  List,
  ListItem,
  ListItemText,
  ClickAwayListener,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { getAllDealers } from "../services/dealerServices";
import { searchVWOnboardedDealer } from "../services/dealeronboard";

export const AdminDealerSearch = ({onSelect}) => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState(null);
  const [allDealersData ,setAllDealersData] = useState(false);

  const handleSearch = async () => {
    if (!query.trim()) return;
    setAllDealersData(false)
    try {
      setLoading(true);
      const vwOnBoardedRes = await searchVWOnboardedDealer(query);
      console.log("search vwOnBoardedRes response : ", vwOnBoardedRes);
      let data = vwOnBoardedRes.data;
      if(!data.length>0){
      setAllDealersData(true);
      const response = await getAllDealers(query);
      console.log("search response : ", response);
      data = response.data;
      }

      setResults(data || []);
      setOpen(true);
    } catch (error) {
      console.error("Search failed:", error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  const handleResultClick = (dealer) => {
    setQuery(`${dealer.dealerId} - ${dealer.dealerName}`);

    console.log("Selected dealer:", dealer);
    setSelectedDealer(dealer);
    setOpen(false);
    onSelect(dealer,allDealersData);
  };

  const handleClear = () => {
    setQuery("");
    setResults([]);
    setSelectedDealer(null);
    setOpen(false);
    setAllDealersData(false)
  };

  return (
    <div style={{position:"relative",width:450}}>
      <TextField
        fullWidth
        //label="Search Dealer"
        placeholder="Search Dealer"
        variant="outlined"
        sx={{
          "& .MuiOutlinedInput-root": {
            width: 450,
            height: 40,
            paddingLeft: 1,
            borderRadius: "20px",
          },
        }}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={selectedDealer ? handleClear : handleSearch}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={20} />
                ) : selectedDealer ? (
                  <CloseIcon style={{ fill: "#C5172E" }}/>
                ) : (
                  <SearchIcon style={{ fill: "#ffc400" }} />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {open && results.length > 0 && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper
            style={{
              position: "absolute",
              zIndex: 10,
              width: "100%",
              marginTop: 4,
              maxHeight: 250,
              overflowY: "auto",
            }}
          >
            <List dense>
              {results.map((dealer,index) => (
                <ListItem
                  key={index}
                  button
                  onClick={() => handleResultClick(dealer)}
                >
                  <ListItemText
                    primary={`${dealer.dealerId} - ${dealer.dealerName} - ${dealer.tenantId} - ${dealer.tenantName? dealer.tenantName : 'N/A'}`}
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </ClickAwayListener>
      )}
    </div>
  );
};
